var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuViewTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 32,
    viewBox: "0 0 211 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 31.26C10.88 31.26 7.26667 29.86 4.36 27.06C1.45333 24.2333 0 20.5933 0 16.14C0 11.66 1.48 7.97999 4.44 5.09999C7.42667 2.19332 11.04 0.73999 15.28 0.73999C17.8933 0.73999 20.32 1.28666 22.56 2.37999C24.8 3.44666 26.6 4.89999 27.96 6.73999L23.64 11.14C21.4 8.44666 18.7333 7.09999 15.64 7.09999C13.1867 7.09999 11.1067 7.95332 9.4 9.65999C7.69333 11.3667 6.84 13.5133 6.84 16.1C6.84 18.6333 7.68 20.74 9.36 22.42C11.04 24.1 13.12 24.94 15.6 24.94C18.8 24.94 21.5333 23.58 23.8 20.86L28.24 25.02C26.8533 26.9133 25 28.4333 22.68 29.58C20.36 30.7 17.8667 31.26 15.2 31.26Z",
    fill: "#00C8D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.08 30.82C40.72 30.82 37.9067 29.8467 35.64 27.9C33.3733 25.9533 32.24 23.0467 32.24 19.18V0.73999H38.88V18.9C38.88 20.7133 39.3333 22.0867 40.24 23.02C41.1733 23.9533 42.4533 24.42 44.08 24.42C45.6533 24.42 46.9067 23.9533 47.84 23.02C48.7733 22.06 49.24 20.6867 49.24 18.9V0.73999H55.88V19.18C55.88 23.02 54.76 25.9267 52.52 27.9C50.3067 29.8467 47.4933 30.82 44.08 30.82Z",
    fill: "#00C8D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.68 25.98L82.72 0.73999H85.32L73.32 30.3H72.04L59.88 0.73999H62.56L72.68 25.98Z",
    fill: "#00C8D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3199 30.3V0.73999H91.7599V30.3H89.3199Z",
    fill: "#00C8D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.64 30.3H95.76V0.73999H113.56V3.05999H98.2V14.18H112.52V16.46H98.2V27.98H113.64V30.3Z",
    fill: "#00C8D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.72 30.3H127.52L117.64 0.73999H120.12L128.16 25.46L136.64 0.73999H137.72L146.32 25.42L154.28 0.73999H156.72L146.92 30.3H145.72L137.2 5.41999L128.72 30.3Z",
    fill: "#00C8D5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.68 30.3V3.09999H160.72V0.73999H181.08V3.09999H172.12V30.3H169.68Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.88 25.98L207.92 0.73999H210.52L198.52 30.3H197.24L185.08 0.73999H187.76L197.88 25.98Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuViewTv);
export default __webpack_public_path__ + "static/media/CuViewTV.634b5d4fbd9965ad3b1881f52d71fa01.svg";
export { ForwardRef as ReactComponent };